<div class="container">
  <app-sb-navbar *ngIf="links.length > 0" [links]="links" [isQcAdmin]="isQcAdmin"></app-sb-navbar>

  <div *ngIf="displayIpadBanner" class="ipad-banner">
    <div class="text">
      <span>{{'general.HEADS_UP' | transloco}}</span>
      <span>{{'general.USE_HEADPHONES_FOR_OPTIMAL_AUDIO' | transloco}}</span>
    </div>
  </div>
  <router-outlet></router-outlet>
</div>
